import React, { useState } from 'react';

export default function CreditCardInput() {
    const [card, setCard] = useState('');

    const handleChange = (e) => {
        const rawValue = e.target.value.replace(/\D/g, ''); // Remove non-digits

        // Chunk numbers into groups of 4 separated by spaces
        const maskedValue = rawValue.match(/.{1,4}/g)?.join(' ') || '';

        // Cap length for standard 16 digit card (plus 3 spaces = 19)
        if (maskedValue.length <= 19) {
            setCard(maskedValue);
        }
    };

    return (
        <div>
            <label>Card Number: </label>
            <input
                type="text"
                value={card}
                onChange={handleChange}
                placeholder="0000 0000 0000 0000"
            />
        </div>
    );
}
